var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLogin
    ? _c("div", { attrs: { id: "header-clover" } }, [
        _c(
          "div",
          { staticClass: "header-clover-wrapper" },
          [
            _c("img", {
              staticClass: "clover-img",
              attrs: {
                src: `${_vm.$s3}/img/common/Header/clover.webp?${_vm.$ver}`,
              },
            }),
            _c("roller", {
              staticClass: "header-clover",
              attrs: {
                text: String(_vm.usrClover),
                isNumberFormat: true,
                transition: 0.5,
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }